"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOVU_ENCRYPTION_SUB_MASK = void 0;
exports.NOVU_ENCRYPTION_SUB_MASK = 'nvsk.';
